// extracted by mini-css-extract-plugin
var _1 = "GotProblems__image--lbQGw";
var _2 = "GotProblems__link--koTvR";
var _3 = "GotProblems__main--xmUxm CoreGeneral__roboto--UlmjE";
var _4 = "GotProblems__message--M_pnU";
var _5 = "GotProblems__messageSevere--bero3";
var _6 = "GotProblems__textContainer--y8QM3";
export { _1 as "image", _2 as "link", _3 as "main", _4 as "message", _5 as "messageSevere", _6 as "textContainer" }
